import React, { useId, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import Card from "../Card";
import EmailInput from "../Form/EmailInput";
import PasswordInput from "../Form/PasswordInput";
import Button from "../Button";
import Modal from "../../components/Modal";
import TextInput from "../Form/TextInput";

import useUserStore from "../../store/User.store";

import "./resetPasswordCard.scss";

const RequestPasswordCard = (props) => {
  const handleResetPassword = useUserStore(
    (state) => state.actions.handleResetPassword
  );

  const [showErrorModal, setShowErrorModal] = useState(false);

  const methods = useForm({
    mode: "onTouched",
  });
  const loginEmailValue = methods.watch("loginEmail");
  const loginPasswordValue = methods.watch("loginPassword");
  const loginPasswordConfirmValue = methods.watch("loginPasswordConfirm");
  const tokenValue = methods.watch("token");

  const navigate = useNavigate();

  const handleSubmitResetPassword = async (data) => {
    const res = await handleResetPassword(data);

    if (res.responseCode === 200) {
      navigate("/signin");
    } else {
      setShowErrorModal(true);
    }
  };

  const id = useId();

  return (
    <>
      <FormProvider {...methods}>
        <Card
          {...props}
          id={id}
          className="card--reset-password"
          title="Create New Password"
          description="Enter the token you received in your company email to reset your password. Passwords must be at least 10 characters long and contain a number, a symbol, and a capital letter."
          collapsible={false}
          openByDefault={true}
        >
          <div className="card__content">
            <form
              className="card__reset-password-form"
              onSubmit={methods.handleSubmit(handleSubmitResetPassword)}
            >
              <EmailInput name="loginEmail" label="Email" />
              <TextInput register={false} name="token" label="Token" />
              <PasswordInput
                name="loginPassword"
                label="New Password"
                showForgotPassword={false}
                shouldValidatePassword={true}
              />
              <PasswordInput
                name="loginPasswordConfirm"
                label="Confirm New Password"
                showForgotPassword={false}
                shouldValidatePassword={true}
                matchPassword={loginPasswordValue}
              />
              <Button
                size="medium"
                disabled={
                  !loginEmailValue ||
                  !loginPasswordValue ||
                  !loginPasswordConfirmValue ||
                  !tokenValue ||
                  methods.formState.errors.loginEmail
                }
                className="card__reset-password-submit-button"
              >
                Reset Password
              </Button>
            </form>
          </div>
        </Card>
      </FormProvider>
      <Modal
        show={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        heading="Error Resetting Password"
        subtitle="Make sure your company email was entered correctly."
        cancelButton={{
          variant: "outline",
          children: "Retry",
        }}
      />
    </>
  );
};

export default RequestPasswordCard;
